import { type BaseContentObject, createBaseContentObject } from './content-object/base-content-object';
import { type Post, createPostInContentObject } from './post';
import type { JournalNoteDataObject } from './service/journal';
import { createUploadedFile } from './uploaded-file';

export type JournalNote = {
  contentableType?: never;
  post: Post;
  sharedContentObjectId?: string;
  type: 'post';
} & BaseContentObject;

export const createJournalNote = (data: JournalNoteDataObject): JournalNote => ({
  ...createBaseContentObject(data),
  attachments: data.attachments.map((attachment) => createUploadedFile(attachment)),
  post: createPostInContentObject(data.post),
  sharedContentObjectId: data.shared_content_object?.id,
  type: 'post',
});

export const isJournalNote = (contentObject: {
  contentableType?: string;
  post?: unknown;
}): contentObject is JournalNote => !contentObject.contentableType && Boolean(contentObject.post);
